var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptTextWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4832 7.7219V10.581C26.4832 12.4477 25.3018 13.6292 23.4351 13.6292H19.3945V5.37081C19.3945 4.0594 20.4697 2.99609 21.7811 2.99609C23.0689 3.00791 24.2503 3.52775 25.101 4.37839C25.9516 5.24085 26.4832 6.4223 26.4832 7.7219Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85547 8.90335V25.4437C2.85547 26.4243 3.966 26.9796 4.74576 26.3888L6.76607 24.8766C7.23865 24.5221 7.90027 24.5694 8.3256 24.9947L10.2868 26.9677C10.7475 27.4285 11.5037 27.4285 11.9645 26.9677L13.9493 24.9829C14.3628 24.5694 15.0244 24.5221 15.4852 24.8766L17.5055 26.3888C18.2853 26.9677 19.3958 26.4125 19.3958 25.4437V5.359C19.3958 4.0594 20.4591 2.99609 21.7587 2.99609H8.76273H7.58127C4.03692 2.99609 2.85547 5.11089 2.85547 7.7219V8.90335Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58008 11.2656H14.6688",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4668 15.9922H13.7833",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptTextWhite);
export default __webpack_public_path__ + "static/media/receipt-text-white.56929c099b96c56339528c38fb533367.svg";
export { ForwardRef as ReactComponent };